import { render, staticRenderFns } from "./selectSettlementData.vue?vue&type=template&id=635119b8&scoped=true"
import script from "./selectSettlementData.vue?vue&type=script&lang=js"
export * from "./selectSettlementData.vue?vue&type=script&lang=js"
import style0 from "./selectSettlementData.vue?vue&type=style&index=0&id=635119b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635119b8",
  null
  
)

export default component.exports